<template>
  <base-modal-component
    :header="false"
    height="530px"
    width="360px"
    :zindex="3"
    padding="1.25rem"
    @close="$emit('close')"
  >
    <template #body>
      <div
        class="text-center text-lg h-full flex flex-col justify-evenly items-center"
      >
        <img
          src="@/assets/image/marketing/ic_event_bell.webp"
          class="w-[70px]"
        />
        <div class="text-base font-semibold text-black9 tracking-[-1.2px]">
          <span class="text-primary">{{ userName }}</span
          >님을 위한 특별한 혜택!
        </div>
        <div
          class="text-xs font-medium text-black9 tracking-[-0.87px] leading-5"
        >
          이벤트 및 혜택정보 수신에 동의하시고 <br />디포스트 이용에 필요한
          다양한 소식을 쉽고 빠르게 받아보세요!
        </div>
        <img
          src="@/assets/image/marketing/img_event_content.webp"
          class="w-full"
        />
        <div class="text-[10px] text-black6 tracking-[-1px]">
          이벤트 및 혜택 정보 수신 동의는
          <span class="underline font-semibold">마이페이지 > 회원정보</span>에서
          변경 가능합니다.
        </div>
        <button
          class="w-full bg-primary text-white text-sm"
          @click.once="updateMarketing(true)"
        >
          좋아요!
        </button>
        <div
          class="underline text-black7 text-xs cursor-pointer font-medium"
          @click.once="updateMarketing(false)"
        >
          아니요, 괜찮습니다.
        </div>
      </div>
    </template>
  </base-modal-component>
</template>

<script lang="ts" setup>
import { useClient } from "@/lib/_API/useClient";

import BaseModalComponent from "@/components/baseComponent/baseModal.vue";

const store = useStore();
const { updateMarketingAgreement } = useClient();
const userName = store.state.auth.clientInfo.name;

const updateMarketing = async (agreement: boolean) => {
  const payload = {
    agreement: agreement,
  };
  try {
    const { code, success } = await updateMarketingAgreement(payload);
    store.dispatch("auth/updateMarketingAgreement", agreement);
    store.dispatch("localStorage/saveToLocalStorage");
  } catch (e) {
    console.error(e);
  }
};
</script>

<script lang="ts">
import { computed } from "vue";

import { useStore } from "vuex";
export const marketingInfo = () => {
  const store = useStore();
  const isMarketingRender = computed(() => {
    return (
      store.state.auth.sessionToken &&
      store.state.auth.marketingAgreement === null
    );
  });

  return {
    isMarketingRender,
  };
};
</script>
<style scoped lang="scss">
.modal-container {
  padding: 1.25rem;
}
</style>
